import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import { decodeFromBase64 } from '../base64';
/**
 * Decode a JWT token
 */

export function decodeJWTtoken(token) {
  var _context;
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // no need to check availability of `encodeURIComponent`, since it is a function highly supported in browsers, node and other platforms.

  var jsonPayload = decodeURIComponent(_mapInstanceProperty(_context = decodeFromBase64(base64).split('')).call(_context, function (c) {
    var _context2;
    return '%' + _sliceInstanceProperty(_context2 = '00' + c.charCodeAt(0).toString(16)).call(_context2, -2);
  }).join(''));
  return JSON.parse(jsonPayload);
}